import currentUserDetailsReducersMapObject from '@ane/exp-data/lib/userDetails/CurrentUserDetailsReducer';
import GetWorkspaceReducersMapObject from '@ane/exp-ux/lib/components/GetWorkspace/GetWorkspace.ducks';
import UserAccessReducersMapObject from '@ane/exp-ux/lib/components/GetUserAccess/UserAccess.reducer';
import HelpReducer from './views/Help/ducks/HelpReducer';
/**
 * Create an object that can simply be merged with the exp-ui reducer { ...reducers, ...analysisReducer }
 * this will map to state.analysis[branch]
 */
//: ReducersMapObject<IModuleState, any>
export const moduleReducer = Object.assign(Object.assign(Object.assign({ help: HelpReducer }, currentUserDetailsReducersMapObject), GetWorkspaceReducersMapObject), UserAccessReducersMapObject);
export default moduleReducer;

//# sourceMappingURL=reducers.js.map
